import _ from 'lodash';

import {
  ImportEmployeeInput,
  useImportNetSuiteEmployeesMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';



export function useImportNetSuiteEmployees() {
  const [fnMutate, tuple] = useImportNetSuiteEmployeesMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = __formatTransform(rows);
      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



function __formatTransform(rawCsvRows: Array<_.Dictionary<string>>): ImportEmployeeInput[] {
  const rowsAsPropertyName2Value = _.map(rawCsvRows, (row): ImportEmployeeInput => {
    return {
      netSuiteInternalId: row['Internal ID'],
      fullName: row['Name']
    };
  });

  return rowsAsPropertyName2Value;
}
